export const DELIVERY_WORK_QUERY_KEY = 'action' as const
export const DELIVERY_WORK_ACTION = {
  START_SHIPMENT: 'START_SHIPMENT',
} as const
